<template>
  <div class="topic">
    <div class="header">

      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleClick">创建</el-button>

      <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>

    </div>

    <el-table :data="list" class="table">
      <el-table-column prop="title" label="标题" width="250"></el-table-column>
      <el-table-column prop="title_en" label="标题(英文)" width="250"></el-table-column>
      <el-table-column label="封面" width="180">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb  + '?imageView2/2/w/200|imageslim'">
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="180">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
	  <el-table-column label="权重" width="80">
	    <template slot-scope="scope">
	      <p>
	        <span>{{scope.row.weight}}</span>
	        <el-button size="small" type="text" icon="el-icon-edit" @click="setWeight(scope.row)"></el-button>
	      </p>
	    </template>
	  </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showAppPath(scope.row)">路径</el-button>
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="edit?'编辑':'创建'" :visible.sync="dialogVisible" width="1100px">
      <el-form ref="form" :model="form" label-width="110px" size="small">
        <el-form-item label="封面" prop="thumb">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb">
          <div v-else class="addimg" @click="selectThumb">+</div>
        </el-form-item>
        <el-form-item label="轮播图" prop="images">
          <div class="images">
            <img v-for="item in form.images" :key="item" class="thumb cursor-pointer" :src="item" @click="selectThumb2">
            <div class="addimg" @click="selectThumb2">+</div>
          </div>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="标题(英文)" prop="title_en">
          <el-input v-model="form.title_en" placeholder="标题(英文)"></el-input>
        </el-form-item>
        <el-form-item label="标题下键" prop="title_key">
          <el-input v-model="form.title_key" placeholder="标题下键"></el-input>
        </el-form-item>
        <el-form-item label="标题下键(英文)" prop="title_key_en">
          <el-input v-model="form.title_key_en" placeholder="标题下键(英文)"></el-input>
        </el-form-item>
        <el-form-item label="标题下值" prop="title_value">
          <el-input v-model="form.title_value" placeholder="标题下值"></el-input>
        </el-form-item>
        <el-form-item label="标题下值(英文)" prop="title_value_en">
          <el-input v-model="form.title_value_en" placeholder="标题下值(英文)"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input v-model="form.year" placeholder="年份"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" placeholder="描述" :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="描述(英文)" prop="description_en">
          <el-input v-model="form.description_en" type="textarea" placeholder="描述(英文)" :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="专题分类" prop="tag_id">
          <el-select v-model="form.tag_id" placeholder="请选择">
            <el-option
              v-for="item in tags"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="艺术家" prop="artists">
          <div class="artist" v-for="(item,index) in form.artists" :key="index">
            <el-select v-model="item.people_id" filterable placeholder="请选择" style="width:150px">
              <el-option
                v-for="item in people"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input v-model="item.title" placeholder="标题" style="width:160px"></el-input>
            <el-input v-model="item.title_en" placeholder="标题(英文)" style="width:160px"></el-input>
            <el-input v-model="item.sub_title" placeholder="副标题" style="width:160px"></el-input>
            <el-input v-model="item.sub_title_en" placeholder="副标题(英文)" style="width:160px"></el-input>
            <el-button type="text" size="mini" @click="artistUp(index)" style="margin-left:6px;">上移</el-button>
            <el-button type="text" size="mini" @click="artistDown(index)">下移</el-button>
            <el-button type="text" size="mini" @click="deleteArtist(index)">删除</el-button>
          </div>
          <el-button icon="el-icon-plus" @click="handlePushArtists">添 加</el-button>
        </el-form-item>
        <el-form-item label="作品列表">
          <el-select v-model="form.movie" multiple filterable placeholder="请选择" style="width:350px;">
            <el-option
              v-for="item in movie"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章列表" prop="articles">
          <div class="article-item" v-for="(item,index) in form.articles" :key="index">
            <el-input class="input" v-model="item.title" placeholder="标题"></el-input>
            <el-input class="input" type="textarea" v-model="item.description" placeholder="描述"></el-input>
            <el-input class="input" v-model="item.link" placeholder="链接"></el-input>
            <div class="btns">
              <el-button type="text" size="mini" @click="articleUp(index)">上移</el-button>
              <el-button type="text" size="mini" @click="articleDown(index)">下移</el-button>
              <el-button type="text" size="mini" @click="deleteArticle(index)">删除</el-button>
            </div>
          </div>
          <el-button icon="el-icon-plus" @click="handlePushArticles">添 加</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="!edit" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="edit" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'topic',
  components: {
    UploadImg
  },
  data () {
    return {
      list: [],
      edit: false,
      dialogVisible: false,
      dialogVisible2: false,
      miniAppPath: '',
      tags: [],
      people: [],
      movie: [],
      articles: [],
      current: {},
      form: {
        year: '',
        thumb: '',
        images: [],
        title: '',
        title_en: '',
        title_key: '',
        title_key_en: '',
        title_value: '',
        title_value_en: '',
        description: '',
        description_en: '',
        tag_id: '',
        artists: [],
        movie: [],
        articles: []
      },
      key: ''
    }
  },
  created () {
    this.getPeople()
    this.getMovie()
    this.getTags()
    this.getTopic()
  },
  watch: {
    key () {
      this.page = 1
      this.getTopic()
    }
  },
  methods: {
    setWeight (row) {
      this.$prompt('请输入', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        request({
          url: '/movie/topics/' + row.uuid,
          method: 'patch',
          data: {
            type: 'update',
            attributes: {
              weight: value
            }
          }
        }).then(() => {
          this.getTopic()
        })
      }).catch(() => {})
    },
    showAppPath (row) {
      this.miniAppPath = 'pages/topicMovieDetail/index?uuid=' + row.uuid
      this.dialogVisible2 = true
    },
    change (e, row) {
      request({
        url: '/movie/topics/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getTopic()
      })
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/topics/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getTopic()
        })
      }).catch()
    },
    editItem (row) {
      this.edit = true
      this.current = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.form = {
        year: row.year,
        thumb: row.thumb,
        images: row.images,
        title: row.title,
        title_en: row.title_en,
        title_key: row.title_key,
        title_key_en: row.title_key_en,
        title_value: row.title_value,
        title_value_en: row.title_value_en,
        description: row.description,
        description_en: row.description_en,
        tag_id: row.tag_id,
        artists: row.artists,
        movie: row.movie,
        articles: row.articles
      }
    },
    handlePushArtists () {
      this.form.artists.push({
        people_id: '',
        title: '',
        sub_title: '',
        title_en: '',
        sub_title_en: ''
      })
    },
    artistUp (index) {
      if (index === 0) return
      let pre = this.form.artists[index - 1]
      this.form.artists.splice(index - 1, 1)
      this.form.artists.splice(index, 0, pre)
    },
    artistDown (index) {
      if (index === this.form.artists.length - 1) return
      let next = this.form.artists[index + 1]
      this.form.artists.splice(index + 1, 1)
      this.form.artists.splice(index, 0, next)
    },
    deleteArtist (index) {
      this.form.artists.splice(index, 1)
    },
    handlePushArticles () {
      this.form.articles.push({
        title: '',
        description: '',
        link: ''
      })
    },
    articleUp (index) {
      if (index === 0) return
      let pre = this.form.articles[index - 1]
      this.form.articles.splice(index - 1, 1)
      this.form.articles.splice(index, 0, pre)
    },
    articleDown (index) {
      if (index === this.form.articles.length - 1) return
      let next = this.form.articles[index + 1]
      this.form.articles.splice(index + 1, 1)
      this.form.articles.splice(index, 0, next)
    },
    deleteArticle (index) {
      this.form.articles.splice(index, 1)
    },
    handleClick () {
      this.edit = false
      this.dialogVisible = true
      this.form = {
        year: '',
        thumb: '',
        images: [],
        title: '',
        title_en: '',
        title_key: '',
        title_key_en: '',
        title_value: '',
        title_value_en: '',
        description: '',
        description_en: '',
        tag_id: '',
        artists: [],
        movie: [],
        articles: []
      }
    },
    submit () {
      request({
        url: '/movie/topics',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功!')
        this.getTopic()
        this.dialogVisible = false
      })
    },
    saveChange () {
      request({
        url: '/movie/topics/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('更新成功!')
        this.getTopic()
        this.dialogVisible = false
      })
    },
    selectThumb () {
      let list = []
      if (this.form.thumb) {
        list = [this.form.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.thumb = res[0]
        }
      }).catch(_ => {})
    },
    selectThumb2 () {
      let list = this.form.images
      this.$refs.upload.show(list, 'other', 10).then(res => {
        this.form.images = res || []
      }).catch(_ => {})
    },
    getPeople () {
      request({
        url: '/movie/people'
      }).then(res => {
        this.people = res.data.list
      })
    },
    getMovie () {
      request({
        url: '/movie'
      }).then(res => {
        this.movie = res.data.list
      })
    },
    getTags () {
      request({
        url: '/movie/topic-tags'
      }).then(res => {
        this.tags = res.data.list
      })
    },
    getTopic () {
      request({
        url: '/movie/topics',
        params: {
          per_page: this.per_page,
          page: this.page,
          type: this.type,
          key: this.key
        }
      }).then(res => {
        this.list = res.data.list
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
  .thumb {
    height: 50px;
    width: auto;
  }
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
  margin-right: 8px;
}
.images {
  display: flex;
  flex-wrap: wrap;
}
.article-item {
  padding: 10px;
  background-color: #f8f8f8;
  margin-bottom: 16px;
  .input {
    margin-bottom: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topic/index.vue